module.exports = "/wwwroot/img/logo_Strip_element_block.png?ver=5ad09d10";